import { IconFunctionalInformation12, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { NBSP } from 'shared/constants';

import * as styles from './PurchaseTermsModal.css';

interface IPurchaseTermsModalProps {
  termsList: React.ReactNode;
  promo: React.ReactNode;
}

export const PurchaseTermsModal: React.FC<IPurchaseTermsModalProps> = ({ termsList, promo }) => {
  return (
    <div className={styles['container']} data-testid="PurchaseTermsModal">
      <div className={styles['terms-list']}>{termsList}</div>
      {promo}
      <div className={styles['disclaimer']}>
        <div className={styles['disclaimer-icon']}>
          <IconFunctionalInformation12 />
        </div>
        <div className={styles['disclaimer-text']}>
          <UIText2>
            Возможны другие варианты — позвоните застройщику. Он поможет{NBSP}выбрать тот, который{NBSP}подойдёт именно
            {NBSP}вам
          </UIText2>
        </div>
      </div>
    </div>
  );
};
